export class SessionUser {
  id: any = -1
  token: any = null
  params: any = {}
  rights: Array<any> = []
}
